import { NavigationGuardNext, Route } from "vue-router";

export const AuditHistoryManagerRouteResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const actions: Promise<void>[] = [];
	await Promise.all(actions);
	next();
};
